import {selectKunde} from "../kundeSelector";
import {getArtistToken} from "../../auth/token.saga";
import {deleteKunde} from "../../../api/kundenApi";
import {invalidateKundeQueries} from "../../../components/kunde/kundeQueries";
import {queryClient} from "../../../config/queryClient";
import {emitNotificationAction} from "../../notification/notificationAction";
import {createErrorNotification, createInfoNotification} from "../../../models/notification";
import i18next from "i18next";
import {i18_KUNDE} from "../../../i18nReferences";
import {clearKundeAction, DELETE_KUNDE} from "../kundeAction";
import {pushHistory} from "../../router/routerActions";
import {getKundeBackNavigationTarget} from "./deleteKundeNavigation";
import {put, takeLatest, select, call} from "redux-saga/effects"

function* processDeleteKunde({payload}) {
    let kunde = yield select(state => selectKunde(state))
    try {
        const token = yield getArtistToken()
        if (token && payload.kundId) {
            yield call(deleteKunde, {token, kundId: payload.kundId})
            yield call(invalidateKundeQueries, queryClient)
            yield put(pushHistory(getKundeBackNavigationTarget(payload.back)))
            yield put(clearKundeAction())
            yield put(emitNotificationAction(createInfoNotification(i18next.t('EDIT_KUNDE.DELETION_SUCCESS_INFO',
                {ns: i18_KUNDE, name: kunde?.Name}), 'deleteKunde')))
        }
    } catch (err) {
        yield put(emitNotificationAction(createErrorNotification(i18next.t('EDIT_KUNDE.DELETION_FAILURE_INFO',
            {ns: i18_KUNDE, name: kunde?.Name}), 'deleteKunde')))
        console.log(err)
    }
}

export function* watchDeleteKunde() {
    yield takeLatest(DELETE_KUNDE, processDeleteKunde)
}
